// extracted by mini-css-extract-plugin
export var contrastLow = "_3a-1";
export var externalLink = "_3a-2";
export var externalLinkIcon = "_3a-3";
export var link = "_3a-0";
export var linkLabel = "_3a-4";